import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PushNotificationService } from '../../services/push-service/push-notification.service';

@Component({
  selector: 'ios-instruction-banner',
  templateUrl: './ios-instruction-banner.component.html',
  styleUrls: ['./ios-instruction-banner.component.scss'],
})
export class IosInstructionBannerComponent implements OnInit, OnDestroy {
  private iosLimitationSubscription?: Subscription;
  isVisible: boolean = false;

  constructor(private pushNotificationService: PushNotificationService) {}

  ngOnInit(): void {
    this.iosLimitationSubscription =
      this.pushNotificationService.iosLimitationDetected$.subscribe(
        (detected) => {
          if (
            detected &&
            this.pushNotificationService.shouldShowIOSInstructions()
          ) {
            this.isVisible = true;
            this.updateBodyPadding();
          }
        }
      );
  }

  ngOnDestroy(): void {
    if (this.iosLimitationSubscription) {
      this.iosLimitationSubscription.unsubscribe();
    }
    this.removeBodyPadding();
  }

  dismiss(): void {
    this.isVisible = false;
    this.removeBodyPadding();
  }

  dismissPermanently(): void {
    localStorage.setItem('ios-instruction-dismissed', 'true');
    this.isVisible = false;
    this.removeBodyPadding();
  }

  private updateBodyPadding(): void {
    const bannerHeight = 120;
    document.body.style.paddingTop = `${bannerHeight}px`;
  }

  private removeBodyPadding(): void {
    document.body.style.paddingTop = '';
  }
}
